import { useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { IntlProvider } from 'react-intl'
import KioskAppBar from './kioskAppBar'
import i18n from '../i18n'
import enMessages from '../locales/en/translation.json'
import fiMessages from '../locales/fi/translation.json'
import AppRoutes from './appRoutes'
import { SS_APP_SETTINGS_KEY } from '../hooks/globalKeys'
import { ToastContainer } from 'react-toastify'

export type Language = 'en' | 'fi'

const messageResources = {
  en: enMessages,
  fi: fiMessages
}

const storedAppSettings = JSON.parse(
  localStorage.getItem(SS_APP_SETTINGS_KEY) || '{}'
)
const initialLanguage: Language = storedAppSettings.defaultLanguage || 'fi'

const queryClient = new QueryClient()

function App() {
  const [currentLanguage, setCurrentLanguage] = useState<Language>(() => {
    return (localStorage.getItem('locale') as Language) || initialLanguage
  })

  const messages = messageResources[currentLanguage] || enMessages

  useEffect(() => {
    i18n.changeLanguage(currentLanguage)
    localStorage.setItem('locale', currentLanguage) 
  }, [currentLanguage])

  const handleLanguageChange = (newLanguage: Language) => {
    setCurrentLanguage(newLanguage)
  }

  return (
    <IntlProvider locale={currentLanguage} messages={messages}>
      <QueryClientProvider client={queryClient}>
        <KioskAppBar
          language={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
        <ToastContainer position="top-right" />
        <AppRoutes />
      </QueryClientProvider>
    </IntlProvider>
  )
}

export default App
